const priceContracts: { cakeAddress: string, busdAddress: string, lpAddress: string, bnbAddress: string, bnbbusd: string } = {
  cakeAddress: '0xb96Bc98eA6A98dB32fa9Af72cD96058318e02E60',
  busdAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  lpAddress: '0xd44F8b91bF365A17f0F0FE0a2Ae0bF5532a2cf0B',
  bnbAddress: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  bnbbusd: "0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16"
}

export default priceContracts